import { useFetchFeatureConfiguration } from '@repo/config-services';
import { type FeatureConfigurationFeatureName } from '@repo/utils';

const IS_ENABLED_CONFIG_KEY = 'enabled';

export function useIsFeatureEnabled(featureName: FeatureConfigurationFeatureName): boolean {
  const {
    featureConfiguration,
  } = useFetchFeatureConfiguration();

  const configValue = featureConfiguration?.featureConfiguration?.find(
    (feature) => feature.featureName === featureName && feature.configKey === IS_ENABLED_CONFIG_KEY,
  )?.configValue ?? false;

  return configValue as boolean;
}
